import React from 'react';
import { Eye, AlertTriangle, TrendingUp } from 'lucide-react';

interface FooterProps {
  onNavigate: (sectionId: string) => void;
  onOpenPrivacy: () => void;
  onOpenDisclaimer: () => void;
}

export const Footer: React.FC<FooterProps> = ({
  onNavigate,
  onOpenPrivacy,
  onOpenDisclaimer,
}) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B0C0F] text-white py-14 relative z-[130]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
          <div className="flex items-center gap-3">
            <img 
              src="/images/logo-icon.png" 
              alt="UV Pulser Icon" 
              className="w-10 h-10 object-contain"
              loading="lazy"
            />
            <div className="flex flex-col text-left">
              <span className="text-lg font-semibold tracking-tight text-white">UV Pulser</span>
              <span className="text-[10px] text-cyan-400 font-mono tracking-wide">an aFoundry venture</span>
            </div>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 text-sm">
            <button onClick={() => onNavigate('consumer')} className="text-white/60 hover:text-white transition-colors">Consumer</button>
            <button onClick={() => onNavigate('industrial')} className="text-white/60 hover:text-white transition-colors">Industrial</button>
            <button onClick={() => onNavigate('tech')} className="text-white/60 hover:text-white transition-colors">Technology</button>
            <button onClick={() => onNavigate('specs')} className="text-white/60 hover:text-white transition-colors">Specs</button>
            <button onClick={() => onNavigate('investor')} className="text-[#06B6D4] hover:text-[#22D3EE] font-medium transition-colors">Invest</button>
            <button onClick={() => onNavigate('contact')} className="text-white/60 hover:text-white transition-colors">Contact</button>
          </div>
        </div>
        
        {/* Legal Links */}
        <div className="flex flex-wrap justify-center items-center gap-6 mb-6 text-sm pt-6 border-t border-white/10">
          <button 
            onClick={onOpenPrivacy}
            className="text-white/40 hover:text-cyan-400 transition-colors flex items-center gap-1.5"
          >
            <Eye className="w-4 h-4" /> Privacy Policy
          </button>
          <button 
            onClick={onOpenDisclaimer}
            className="text-white/40 hover:text-cyan-400 transition-colors flex items-center gap-1.5"
          >
            <AlertTriangle className="w-4 h-4" /> Legal Disclaimer
          </button>
          <a 
            href="https://afoundry.ai" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-white/40 hover:text-cyan-400 transition-colors flex items-center gap-1.5"
          >
            <TrendingUp className="w-4 h-4" /> aFoundry Ventures
          </a>
        </div>
        
        <div className="text-center">
          <p className="text-xs text-white/40 font-sans">
            © 2025–{currentYear} UV Pulser (an aFoundry venture). All rights reserved. Pulsed UV-C Water Purification Technology.
          </p>
        </div>
      </div>
    </footer>
  );
};
